module.exports = __webpack_public_path__ + "static/media/yx-bg.88bd5b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yx-bg.png
// module id = 588
// module chunks = 6